import { render, staticRenderFns } from "./CMainMenuHorizontal.vue?vue&type=template&id=589c793d"
import script from "./CMainMenuHorizontal.vue?vue&type=script&lang=js"
export * from "./CMainMenuHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports